import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import boTheme from '@ecp/common/src/style/theme/bo';
import { flexItemPropTypes } from '@ecp/common/src/style/propTypes';
import { overrideProperties } from '@ecp/common/src/style/utils';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Tooltip from '@ecp/common/src/components/tooltip/bo/Tooltip';
import { ReactComponent as QuestionIcon } from '@ecp/common/src/assets/icon/icon__tooltip-question.svg';

const Container = styled(FlexBox)`
  ${overrideProperties(flexItemPropTypes, { 'flex-grow': '1' })};
  flex-basis: ${({ fitContent }) => (fitContent ? 'auto' : '0px')};
  align-items: flex-start;
`;

const Label = styled(FlexBox)`
  width: ${({ labelWidth }) => (labelWidth ? labelWidth : '170px')};
  ${({ fitContent }) => fitContent && 'width: fit-content;'}
  flex-shrink: 0;
`;

const LabelText = styled(TextBox)`
  font-weight: ${({ labelWidth, fitContent }) =>
    labelWidth || fitContent ? boTheme.font.weight.regular : boTheme.font.weight.bold};
  font-size: ${boTheme.font.size.small};
  color: ${boTheme.color.sub1};
  height: 28px;

  ${({ required }) => (required ? 'gap: 3px' : '')};
`;

const Value = styled(FlexBox)`
  flex-grow: 1;
`;

const HelpIcon = styled(QuestionIcon)`
  width: 18px;
  height: 18px;
  margin-left: 6px;
  flex-shrink: 0;
  cursor: pointer;
`;

const SearchItem = ({ children, label, required, labelWidth, fitContent, help, helpValue, labelHeight, ...props }) => {
  return (
    <Container className={'search-item'} fitContent={fitContent} {...props}>
      <Label fitContent={fitContent} labelWidth={labelWidth}>
        <LabelText required={required} fitContent={fitContent} labelWidth={labelWidth} height={labelHeight}>
          {label}
        </LabelText>
        {help && (
          <Tooltip arrow placement={'bottom-start'} value={helpValue}>
            <HelpIcon />
          </Tooltip>
        )}
      </Label>
      {fitContent && <Spacing right={14} />}
      <Value>{children}</Value>
    </Container>
  );
};

SearchItem.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  required: PropTypes.bool,
  fitContent: PropTypes.bool,
  labelWidth: PropTypes.string,
  labelHeight: PropTypes.string,
  help: PropTypes.bool,
  helpValue: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

SearchItem.defaultProps = {
  fitContent: false,
};

export default SearchItem;
